module.exports = __webpack_public_path__ + "media/images/ic-data-f8d2a1c93252a3d1efbe998876a24419.svg";